/* eslint-disable
    radix
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';
import _ from 'underscore';

import {assert} from 'Asserts';
import FolderDAOCache from 'file-browser/FolderDAOCache';
import FolderSelectorView from 'file-browser/FolderSelectorView';
import FolderDefaults, {FolderDefaultsKey} from 'FolderDefaults';
import notifications from 'notifications';
import {withLoadingScreen} from 'util/Promises';
import * as SequenceDAO from 'molbio/dao/SequenceDAO';
import DuplicateModalTemplate from 'molbio/components/DuplicateModalTemplate';

/**
 * @deprecated New UIs should rely on DuplicatePolymerModal.
 */
class DuplicateModal extends Backbone.View {
  static initClass() {
    this.prototype.template = DuplicateModalTemplate;

    this.prototype.events = {
      'change .select-all': 'selectAllToggle',
      'change .copy-list input': 'renderSelectAll',
      'submit form': function (e) {
        e.preventDefault();
        this.clone();
      },
    };
  }

  initialize({analyses, cloneSuccess, initialFolderId, name, sequenceID, version}) {
    this.analyses = analyses;
    this.cloneSuccess = cloneSuccess;
    this.initialFolderId = initialFolderId;
    this.name = name;
    this.sequenceID = sequenceID;
    this.version = version;
    this.clone = this.clone.bind(this);
    if (this.version == null) {
      this.version = 'latest';
    }
    if (this.initialFolderId == null) {
      this.initialFolderId = FolderDefaults.get(FolderDefaultsKey.INVENTORY);
    }
  }

  remove() {
    super.remove();
    if (this.selectorView != null) {
      this.selectorView.remove();
    }
  }

  selectAllToggle(e) {
    const $target = $(e.currentTarget);
    const $list = $target.closest('div').find('.copy-list');
    return $list.find('input').prop({
      checked: $target.prop('checked'),
    });
  }

  renderSelectAll(e) {
    const $list = $(e.currentTarget).closest('ul');
    const $wrapper = $list.closest('div');
    const total = $list.find('input').length;
    const checked = $list.find('input:checked').length;
    const all = checked === total;
    const some = checked > 0;
    return $wrapper.find('.select-all').prop({
      checked: some,
      indeterminate: !all && some,
    });
  }

  renderFolderSelector(selectedFolderId) {
    if (this.selectorView != null) {
      this.selectorView.remove();
    }
    this.selectorView = new FolderSelectorView({
      initialFolderId: selectedFolderId,
      inputClassName: 'folder-select',
      props: {showInventory: true},
    });
    this.$('.folder-selector-container').html(this.selectorView.render().el);
  }

  clone() {
    const name = this.$el.find('.name-input').val();
    if (!name) {
      notifications.error('Please enter a valid name.');
      return;
    }

    const destFolderId = this.$el.find('.folder-select').val();
    if (!destFolderId) {
      notifications.error('Please select a folder.');
      return;
    }

    FolderDefaults.set(FolderDefaultsKey.INVENTORY, destFolderId);
    const copiedAnalyses = this.$el
      .find('input.copied-analysis:checked')
      .map(function () {
        return parseInt($(this).val());
      })
      .get();

    withLoadingScreen(
      SequenceDAO.cloneVersion(this.sequenceID, this.version, destFolderId, name, copiedAnalyses)
        .then((res) => {
          FolderDAOCache.invalidateFolderContents(destFolderId);
          return $.when(this.cloneSuccess(res));
        })
        .catch(notifications.notifyError),
      'Loading...'
    );
  }

  render() {
    this.analyses.forEach((analysis) => assert(_.isNumber(analysis.id))); // check for any unsaved analyses
    this.$el.html(
      this.template({
        name: this.name,
        analyses: this.analyses,
      })
    );
    this.renderFolderSelector(this.initialFolderId);
    return this;
  }
}
DuplicateModal.initClass();

export default DuplicateModal;
